import React from 'react';
import { Button, Typography } from '@material-ui/core';
import { Section, MdSpace } from 'm2m.components';
import { NotaComercialApiResponse } from 'common/genericTypes';
import { documentShortDescriptions } from 'common/genericDescriptions';
import { GetApp, InsertDriveFile } from '@material-ui/icons';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';

interface Props {
  documentos: NotaComercialApiResponse;
}

const DetalhesDocumentosComponent: React.FC<Props> = (props) => {
  const { documentos } = props;
  const dispatch = useDispatch();
  const getInstrumentoDocumentDownloadUrl = useSelector(
    (state: RootState) => state.instrumentoApi.getInstrumentoDocumentDownloadUrl
  );

  const getAttachmentLink = async (documentId: string, name: string) => {
    try {
      const result = await getInstrumentoDocumentDownloadUrl(dispatch, documentId, true);

      if (result) {
        const link = document.createElement('a');
        link.href = result;
        link.target = '_blank';
        link.download = name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Section title={'Documentos'}>
        {documentos.documents.map((_, i) => (
          <div key={i}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                borderBottom: '1px solid #C4C4C4',
                paddingBottom: 40,
              }}
            >
              <Typography variant="body1">{documentShortDescriptions[_.emissionType]}</Typography>
              <div style={{ display: 'flex', alignItems: 'center', alignContent: 'flex-end', textAlign: 'right' }}>
                <InsertDriveFile style={{ marginRight: 10 }} fontSize={'small'} />
                <div style={{ maxWidth: 300, display: 'flex' }}>
                  <Typography
                    style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                    variant="body1"
                  >
                    {_.fileName}
                  </Typography>
                </div>
                <Typography style={{ marginLeft: 10 }}>{`-`}</Typography>
                <Typography style={{ marginLeft: 10 }}>{`${Math.round((_.size / 1000000) * 100) / 100}MB`}</Typography>
                <GetApp style={{ marginLeft: 20 }} />
                <Button onClick={() => getAttachmentLink(_.id, _.fileName)} variant="text">
                  {'Download'}
                </Button>
              </div>
            </div>
            <MdSpace />
          </div>
        ))}
      </Section>
    </>
  );
};

export const DetalhesDocumentos = DetalhesDocumentosComponent;
